var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"label",staticStyle:{"margin-top":"40px","margin-bottom":"10px"}},[_c('translate',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.asterisk)?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48df630e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Label.vue
// module id = 3LY0
// module chunks = 1